
export const state = {
  loading: false,
  payment_methode: {},
  payment_methode:[],
  columns: [],
  paginate: {total:0},
  resp: {}
}
export const mutations = {
  LOADING: (state) => {
    state.loading = true
  },
  PAYMENT_METHODE: (state, payload) => {
    state.payment_methode = payload
    state.loading = false
  },
  LOGIN: (state, payload) => {
    state.payment_methode_session = payload
    state.loading = false
  },
  SET_PAYMENT_METHODES: (state, payload) => {
    state.loading = false
    state.paginate = payload.pagination
    state.payment_methodes = payload.data
  },
  SET_COLUMNS: (state, payload) => {
    state.loading = false
    state.columns = payload
  },
  SET_RESP: (state, payload) => {
    state.loading = false
    state.resp = payload
  },

}

export const actions = {
  POST_PAYMENT_METHODE: async({commit}, payload) => {
    commit("LOADING")
    return await axios({url: 'api/payment_methode', data: payload, method: 'POST'})
        .then(resp => {
            if(resp.data.code == 200) {
                commit("SET_PAYMENT_METHODES", resp.data.data)
            } else {
                commit("SET_RESP", resp.data)
            }
            return resp
        })
},
  GET_PAYMENT_METHODES: async({commit}, args) => {
    commit("LOADING")
      console.log('args ',args)
    var params = queryString.stringify({
      ...{
          limit: 10,
          page: args.page,
          name: null,
          sort: '-id'
      }, ...args}
    )
    return await axios({url: 'api/payment_methode?' + args.params, method: 'GET'})
      .then(resp => {
        if(resp.data.status == '200 OK') {
          commit("SET_PAYMENT_METHODES", resp.data)
        }
        return resp
      })
  },
  GET_COLUMNS: async({commit}) => {
    commit("LOADING")
    return await axios({url: 'api/payment_methode/columns' , method: 'GET'})
      .then(resp => {
        if(resp.data.status == 'success') {
          commit("SET_COLUMNS", resp.data.data)
        }
        return resp
      })
  },
  DELETE_PAYMENT_METHODE: async({commit},cutomerId) => {
    commit("LOADING")
    return await axios({url: 'api/payment_methode/'+cutomerId, method: 'DELETE'})
       .then(resp => {
            if(resp.data.code == 200) {
                    swal({
                        type: 'success',
                        title: 'Status...',
                        text: resp.data.message
                    })
                commit("SET_RESP", resp.data)

      }
      return resp
    })


  },

}

export const getters = {
  payment_methode: state => state.payment_methode,
  payment_methodes: state => state.payment_methodes,
  paginate: state => state.paginate,
  isLoading: state => state.loading,
  resp: state => state.resp,
  columns: state => state.columns
}

// export default {
//   // namespaced: true,
//   state,
//   getters,
//   actions,
//   mutations,
//
// }
